import { Component, Input, OnInit } from '@angular/core';

import { FloodForecastConstants } from './flood-forecast.constant';
import { FloodForecastUtilsService } from './flood-forecast-shared/floodForecastUtils.service';
import { UtilsSharedModule } from '../../shared/utils/utils/utils.module';
import { UtilsService } from 'src/app/utils/utils.service';
import { ConstantsModule } from '../../shared/constants/constants.module';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { InfomodalComponent } from '../../shared/infomodal/infomodal.component';
import { FloodForecastDataService } from './flood-forecast-data.service';
import { FloodForecastMapService } from './flood-forecast-map.service';
import * as moment from 'moment';

@Component({
  selector: 'app-flood-forecast',
  templateUrl: './flood-forecast.component.html',
  styleUrls: ['./flood-forecast.component.scss']
})
export class FloodForecastComponent implements OnInit {

  @Input() map: any;
  @Input() layersList: any;

  regionOptions: any[];
  selectedRegion = 'southZone';
  selectedBasin = '';
  adminSelected: any = true;
  srcParams: any;
  showThrobber = false;
  sourceList: any = [];
  list: any;
  defaultSource = 'IMD';
  defaultAggrType = 'SUM';
  srcList: any;
  src: object = { required: true };
  format: object = { required: true };
  aggr: object = { required: true };
  srcUUID: string;
  minDate: Date;
  maxDate: any;
  defaultFormat: any = 'yyyyMMdd';
  defaultSDate: any;
  customOption = true;
  defaultDateRange = 'Live Weather';
  minMaxselected = 'Max';
  selectedcomp: any;
  tooltipVal: any;
  modalRef: any;
  stateUrlId: any;

  sDate: object = { required: true };
  eDate: object = { required: true };
  ytd: object = { required: true };

  ADMIN = 'ADMIN';
  BASIN = 'BASIN';

  dateDropdown = ['Live Weather', 'Yesterday', 'Last 3 Days', 'Last 7 Days', 'Last 14 Days', 'MTD', 'Monsoon YTD', 'Custom'];

  dashboardView: string = this.ADMIN;
  validation: boolean[] = new Array(5).fill(true);

  selectedView = this.BASIN;
  mapLoaderActive = false;

  currentApplication: any;
  selected: any;
  moduleName: any;
  daterange: any;
  isHistorical: any;
  startValidation = true;
  endValidation = true;
  rainfallFilterOpen = false;
  islayerListOpen = false;
  zoneOptions: any[];
  stateOptions: any[];
  selectedZone: string = ''; // Separate variable for zone
  selectedState: string = ''; // Separate variable for state
  selectedSource: string;
  sourceOptions: string[] = ['Ricken','Radar', 'IMD Radar', 'Radar+ CTT'];
  sourceDataAlert: any = 'RICKEN_NOWCAST';
  regionOptions1: any[];


  constructor(
    private ffUtilService: FloodForecastUtilsService,
    public utilsShared: UtilsSharedModule,
    private utils: UtilsService,
    public constants: ConstantsModule,
    private route: ActivatedRoute,
    private router: Router,
    private flDataService: FloodForecastDataService,
    private floodMapSrv : FloodForecastMapService,
  ) {
    this.selectedRegion = this.ffUtilService.getFloodForecastSelectedRegionValue();
    ffUtilService.getFloodForecastSelectedSideBarApplication().subscribe(value => {
      this.selected = value;
    });
  }

  ngOnInit() {
    this.regionOptions = FloodForecastConstants.REGIONOFINTEREST;
    this.regionOptions1 = FloodForecastConstants.REGIONOFINTEREST1;
    this.ffUtilService.getFloodForecastSelectedRegion().subscribe(region => {
      if (region) {
        // this.selectedRegion = region; // This might need to be adjusted based on your actual data
        // console.log(region,"reg");
        
      }
    });
    this.ffUtilService.getFloodForecastSelectedSource().subscribe(source => {
      if (source) {
        this.selectedSource = source;
      }else {
        this.selectedSource = 'IMD Radar'; // Default to 'Ricken' if no source is set
      }
    });
    // this.setActiveComponent();
    this.initializeOnStateLoad();
  }

  // changeSelectedRegionOfInterest(selectedRegion: string, type: string) {
  //   if (type === 'zone') {
  //     this.selectedZone = selectedRegion;
  //   } else if (type === 'state') {
  //     this.selectedState = selectedRegion;
  //   }
  // }
  changeSelectedRegionOfInterest(type:string,regionName?: string) {
    if (type === 'zone') {
      this.selectedRegion = regionName;
      this.selectedBasin = "";
    } else if (type === 'basin') {
      this.selectedBasin = regionName;
      this.selectedRegion = "";
    }
    this.ffUtilService.setFloodForecastSelectedRegion(regionName);
  }

  sourceChange(data:any){
  this.utils.setSourceAlert(data);
  }

  adminBasinToggle() {
    this.adminSelected = !this.adminSelected;
    this.utils.setAdminBasinToggle(this.adminSelected);
  }

  minMaxToggle(value) {
    this.minMaxselected = value;
    this.utils.minMaxToggle.next(this.minMaxselected.toLowerCase());
  }

  initializeOnStateLoad() {
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
    const paramsForFilter = this.getParams();
    this.adminSelected = false;
    this.dashboardView = this.constants.VIEWS.BASIN;
    this.currentApplication = paramsForFilter['component'];
    if (!this.currentApplication) {
      this.currentApplication = 'RAINFALL';
    }
    // if(!this.checkParams(this.paramsForFilter)){
    // this.setAllOtherParameters(paramsForFilter);
    // }
  }

  checkParams(params) {
    if (params == null || params == undefined) { return false; }
    if (params.component == null || params.component == undefined) { return false; }
    if (params.src == null || params.src == undefined) { return false; }
    if (params.cType == null || params.cType == undefined) { return false; }
    if (params.daterange == null || params.daterange == undefined) { return false; }
    return true;
  }

  getParams() {
    const params = this.ffUtilService.getFloodForecastRfFilterParamsValue();
    const paramsForFilter = Object.assign({}, params);
    if (paramsForFilter['sDate'] != null && paramsForFilter['sDate'] != undefined) {
      paramsForFilter['sDate'] = this.utilsShared.getDateObjectFromModelDate(paramsForFilter['sDate']);
    }
    if (paramsForFilter['eDate'] != null && paramsForFilter['eDate'] != undefined) {
      paramsForFilter['eDate'] = this.utilsShared.getDateObjectFromModelDate(paramsForFilter['eDate']);
    }
    return paramsForFilter;
  }

  // async setAllOtherParameters(options: any) {
  //   const postdata = {
  //     component: this.currentApplication,
  //     state_uuid: this.constants.ANDHRA_PRADESH_UUID
  //   };
  //   this.showThrobber = true;
  //   this.list = await this.flDataService.getSourceListForComponent(postdata).toPromise();
  //   this.showThrobber = false;
  //   let index = this.list.findIndex(src => src['key'] == this.constants.AP_AWS);
  //   if (index == -1) {
  //     index = 0;
  //   }
  //   if (index != 0) {
  //     this.list.splice(0, 0, this.list.splice(index, 1)[0]);
  //   }


  //   this.setFormat(options['format']);
  //   this.DateParams(options);
  //   this.setAggregationValue(options['aggr']);
  //   this.mapLoaderActive = false;
  // }

  DateParams(options) {
    if (options == null || options['undefined']) { options = {}; }
    if (options['daterange'] == null || options['daterange'] == undefined) {
      options['daterange'] = this.defaultDateRange;
    }
    this.daterange = options['daterange'];
    let isHistorical = true;
    if (this.daterange == 'Live Weather') { isHistorical = false; }
    if (this.isHistorical != isHistorical) {
      this.isHistorical = isHistorical;
      this.setSourceInfo();
    }
    this.setStartAndEndDate(options);
  }

  setStartAndEndDate(options) {
    if (this.daterange == 'Custom') {
      this.customOption = false;
      const minDate = this.minDate;
      const maxDate = this.maxDate;
      if ((options.sDate == null) || (options.sDate == undefined) ||
        options.sDate < minDate) {
        options.sDate = minDate;
      } else if ((options.sDate == null) || (options.sDate == undefined) ||
        options.sDate > maxDate) {
        options.sDate = maxDate;
      }
      if ((options.eDate == null) || options.eDate == undefined ||
        options.eDate > maxDate) {
        options.eDate = maxDate;
      } else if ((options.eDate == null) || options.eDate == undefined ||
        options.eDate < minDate) {
        options.eDate = minDate;
      }
      this.sDate['value'] = options.sDate;
      this.eDate['value'] = options.eDate;
    } else {
      this.customOption = true;
      this.setFormat(this.defaultFormat);
      if (this.daterange == 'Live Weather') {
        this.eDate['value'] = this.getLastFewDaysDate(0);
        this.sDate['value'] = this.getLastFewDaysDate(0);
      } else if (this.daterange == 'Yesterday') {
        this.eDate['value'] = this.getLastFewDaysDate(1);
        this.sDate['value'] = this.getLastFewDaysDate(1);
      } else if (this.daterange == 'Last 3 Days') {
        this.eDate['value'] = this.getLastFewDaysDate(1);
        this.sDate['value'] = this.getLastFewDaysDate(3);
      } else if (this.daterange == 'Last 7 Days') {
        this.eDate['value'] = this.getLastFewDaysDate(1);
        this.sDate['value'] = this.getLastFewDaysDate(7);
      } else if (this.daterange == 'Last 14 Days') {
        this.eDate['value'] = this.getLastFewDaysDate(1);
        this.sDate['value'] = this.getLastFewDaysDate(14);
      } else if (this.daterange == 'MTD') {
        this.eDate['value'] = this.getLastFewDaysDate(1);
        this.sDate['value'] = this.getMonthInDateFormat(this.eDate['value']);
      } else if (this.daterange == 'Monsoon YTD') {
        this.eDate['value'] = this.getLastFewDaysDate(1);
        this.sDate['value'] = this.utilsShared.getCurrentMonsoonrYearStartDate();
      }

    }
  }

  getMonthInDateFormat(date) {
    const endDateInModelDate = this.utilsShared.getModelDateWithDateFormat(date, this.format['value']);
    return this.utilsShared.getDateObjectFromModelDate(endDateInModelDate.substr(0, 6) + '01');
  }

  setSourceInfo() {
    if (this.daterange == 'Live Weather') {
      this.sourceList = [];
      this.list.forEach((srcc: any) => {
        const obj = srcc;
        if (srcc['current'] == true) {
          this.sourceList.push(obj);
        }
      });
      this.sourceList.forEach(src => {
        if (src['key'] == this.constants.AP_AWS) {
          this.tooltipVal = src['displayNames']['basin']['info']['current'];
        }
      });

    } else {
      this.sourceList = this.list;
      this.sourceList.forEach(src => {
        if (src['key'] == this.constants.AP_AWS) {
          this.tooltipVal = src['displayNames']['basin']['info']['historical'];
        }
      });
    }

    this.src['value'] = this.sourceList[0]['key'];
    let range;
    this.sourceList.forEach((srcc: any) => {
      if (this.src['value'] == srcc['key']) {
        range = srcc['minmax'];
      }
    });
    this.setMinMax(range);
    this.setYTD(range);
  }

  setMinMax(range: object): void {
    if (!range || !range['MAX'] || range['MAX'] == 0 || !range['MIN'] || range['MIN'] == 0) {
      this.minDate = new Date();
      this.maxDate = new Date();
      return;
    }
    this.minDate = this.utilsShared.getDateObjectFromModelDate(range['MIN'].toString());
    this.maxDate = this.utilsShared.getDateObjectFromModelDate(range['MAX'].toString());
    this.maxDate = (this.maxDate.getTime() > (new Date()).getTime()) ? new Date() : this.maxDate;

  }

  setYTD(data: object): void {
    if (!data || !data['MAX'] || data['MAX'] == 0) { return; }
    this.ytd['value'] = data['MAX'].toString().substr(0, 4);
    Object.assign(this.ytd, data);
  }

  getToolTipValue() {
    return this.tooltipVal;
  }

  setSourceValue(value) {
    this.src['value'] = value;
    if (!this.customOption) {
      const options = {
        sDate: this.sDate['value'],
        eDate: this.eDate['value']
      };
      this.setStartAndEndDate(options);
    }
  }

  setDateRange() {
    const options = {
      daterange: this.daterange,
      sDate: this.sDate['value'],
      eDate: this.eDate['value']
    };
    this.DateParams(options);
  }

  setAggregationValue(aggr: string): void {
    if (aggr == null || aggr == undefined) { aggr = this.defaultAggrType; }
    this.aggr['value'] = aggr;
  }

  setFormat(format: string): void {
    this.format['value'] = format || this.defaultFormat;
    if (this.sDate['value']) {
      delete this.sDate['value'];
    }
    if (this.eDate['value']) {
      delete this.eDate['value'];
    }
    for (let i = 0; i < this.validation.length; i++) {
      this.validation[i] = true;
    }
  }

  getLastFewDaysDate(days) {
    return new Date(Date.now() - days * 24 * 60 * 60 * 1000);
  }

  infoclick(value) {
    // this.modalRef = this.modalService.open(InfomodalComponent,{ backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent'})
    // this.modalRef.componentInstance.selected = value;
    // this.modalRef.componentInstance.infovalue = this.tooltipVal;
    // this.modalRef.componentInstance.selectedDate = this.daterange;
  }

  setUrlParams() {
    const urlParams = this.ffUtilService.getFloodForecastRfFilterParamsValue();
    urlParams['lUUID'] = urlParams['lUUID'] ? urlParams['lUUID'] : this.constants.ANDHRA_PRADESH_UUID;
    urlParams['sUUID'] = urlParams['sUUID'] ? urlParams['sUUID'] : this.constants.ANDHRA_PRADESH_UUID;
    urlParams['view'] = this.dashboardView;
    urlParams['component'] = this.currentApplication;
    urlParams['daterange'] = this.daterange;
    urlParams['format'] = this.format['value'];
    urlParams['src'] = this.src['value'];
    urlParams['aggr'] = this.aggr['value'];
    urlParams['sDate'] = this.utilsShared.getModelDateWithDateFormat(this.sDate['value'], urlParams['format']);
    urlParams['eDate'] = this.utilsShared.getModelDateWithDateFormat(this.eDate['value'], urlParams['format']);
    return urlParams;
  }

  requestHeatMap(): void {

    const urlParams = this.setUrlParams();
    const validate = this.checkAndValidateUrlParams(urlParams);
    if (!validate) { return; }
    urlParams['visible'] = true;
    let navigationParams = this.ffUtilService.checkUrlParams(this.route.snapshot.params);
    navigationParams['sDate'] = urlParams['sDate'];
    navigationParams['eDate'] = urlParams['eDate'];
    navigationParams['showSensorLayer'] = true;
    // console.log("Hello");
    let baseUrl = 'floodforecast/gis' + '/' + this.stateUrlId;
    this.router.navigate([baseUrl, navigationParams]);
    this.ffUtilService.setFloodForecastRfFilterParams(urlParams);

  }

  checkAndValidateUrlParams(urlParams) {
    if (!urlParams['sDate'] || urlParams['sDate'] == '') {
      this.startValidation = false;
      return false;
    }
    if (!urlParams['eDate'] || urlParams['eDate'] == '') {
      this.endValidation = false;
      return false;
    }
    return true;
  }

  setStartDateValidation() {
    this.startValidation = true;
  }

  setEndDateValidation() {
    this.endValidation = true;
  }

  toggleSelectedApplication(value) {
    if (this.selected === value) {
      this.selected = '';
    } else {
      this.selected = value;
    }
    this.ffUtilService.setFloodForecastSelectedSideBarApplication(this.selected);
  }

  getDeviceType() {
    return this.utils.getDeviceType();
  }

  islayerListOpenFun() {
    this.islayerListOpen = !this.islayerListOpen;
  }
}
